import Model from '@/store/plugins/orm/Model'

export class Session extends Model {
    static get entity () {
        return 'sessions'
    }

    static get DATE_FORMAT() {
        return 'YYYY-MM-DDTHH:mm:ssZ';
    }

    static fields () {
        return {
            id: this.attr(null),
            clock_in: this.attr(null),
            clock_out: this.attr(null),
            user_id: this.attr(null),
            ip_address: this.attr(null),

            sync_needed: this.attr(null)
        }
    }

    /**
     * Make a copy of the current session.
     */
    $duplicate() {
        return new Session(this.$toJson());
    }

    /**
     * Open a new session. Called only when offline. When online
     * session is created on the server and stored to client.
     */
    static open(user) {
        const session = new Session({
            user_id: user.id,
            clock_in: moment().utc().format(Session.DATE_FORMAT),
            sync_needed: this.store().getters.tenant.venue.hash
        });

        session.$save();
    }

    /**
     * Close the existing session. Called only when offline. When online
     * session is closed on the server and updated session is stored to client.
     */
    close() {
        this.clock_out = moment().utc().format(Session.DATE_FORMAT);
        this.sync_needed = this.$store().getters.tenant.venue.hash;
        this.$save();
    }
}

export default Session
